<template>
  <div
    v-if="hasAttributes"
    class="product-attributes-fi"
  >
    <div class="product-attributes-fi__label">
      {{ $dict.get('online-Shop.Product.Attributes-Label') }}
    </div>
    <div class="product-attributes-fi__attributes">
      <icon-attribute-item-fi
        v-if="attributeName(attributes, 'ANZAHL_BAUTEILE')"
        icon="puzzle"
        :label="attributeName(attributes, 'ANZAHL_BAUTEILE')"
        :value="attributeValue(attributes, 'ANZAHL_BAUTEILE')"
      />
      <icon-attribute-item-fi
        v-if="attributeName(attributes, 'ANZAHL_MODELLE')"
        icon="module"
        :label="attributeName(attributes, 'ANZAHL_MODELLE')"
        :value="attributeValue(attributes, 'ANZAHL_MODELLE')"
      />
      <icon-attribute-item-fi
        v-if="attributeName(attributes, 'ALTER_AB')"
        icon="age"
        :label="attributeName(attributes, 'ALTER_AB')"
        :value="attributeValue(attributes, 'ALTER_AB')"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { IconAttributeItemFi } from 'atoms';
import { computed } from 'vue';

import { type CatalogAttribute, useCatalogAttributes } from '@/composables/catalogAttributes';

interface Props {
  attributes?: CatalogAttribute[] | null;
}

const props = withDefaults(defineProps<Props>(), {
  attributes: null,
});

const { attributeName, attributeValue } = useCatalogAttributes();

const hasAttributes = computed(() => {
  return Boolean(
    attributeName(props.attributes, 'ANZAHL_BAUTEILE') ||
    attributeName(props.attributes, 'ANZAHL_MODELLE') ||
    attributeName(props.attributes, 'ALTER_AB'),
  );
});
</script>

<style scoped src="./product-attributes-fi" />
